import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useState } from 'react';
import { ExpandMore } from '@mui/icons-material';
import CertificationTypeForm from './form';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';

const AccordionCertificateTypeComponent = (): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls={`panel-request-certificate`}
          id={`panel-request-certificate`}
          expandIcon={<ExpandMore />}
        >
          <Typography>Richiedi Certificato</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <CertificationTypeForm />
        </AccordionDetails>
      </Accordion>
    </>
  );
};

AccordionCertificateTypeComponent.displayName = 'Accordion Certificate Type';

const AccordionCertificateType = memo(AccordionCertificateTypeComponent);

export default AccordionCertificateType;
